<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="-1 -1 18 18"
    fill="none"
    overflow="visible"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9.49512 11.4951C9.73419 11.256 9.76406 10.8869 9.58496 10.6152L9.49512 10.5049L6.99023 8L9.49512 5.49512L9.58496 5.38477C9.76405 5.1131 9.73419 4.74396 9.49512 4.50488C9.25604 4.26581 8.8869 4.23595 8.61523 4.41504L8.50488 4.50488L5.50488 7.50488C5.23152 7.77825 5.23152 8.22175 5.50488 8.49512L8.50488 11.4951L8.61523 11.585C8.8869 11.7641 9.25604 11.7342 9.49512 11.4951Z"
      fill="currentColor"
    />
  </svg>
</template>
